module.exports = __webpack_public_path__ + "img/img-innovative.bd931738.jpg";